import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

/**
 * A component that renders a supplier tile.
 * Will only render if the user is an admin or if the user is registered for the supplier.
 * Will not render if the supplier is cancelled.
 *
 * @param {object} props - The props object.
 * @param {object} props.supplierObject - The supplier object.
 * @param {boolean} props.isActive - Whether the link is active or not.
 * @param {string} props.url - The url to use for the SupplierTile.
 *
 * @example
 * <SupplierTile supplierObject={{}} isActive={true} url="/suppliers/" />
 */
function SupplierTile({ supplierObject, isActive, url }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { custom_page: CustomPage, custom_page_url: CustomPageUrl } =
    supplierObject;

  const linkTo = isActive
    ? CustomPage && url === "/Supplier/"
      ? CustomPageUrl
      : `${url}${supplierObject.id}`
    : CustomPageUrl;

  return (
    <Grid item xs={12} sm={6} md={4} lg={4}>
      <Link
        to={linkTo}
        style={{
          textDecoration: "none",
          pointerEvents: isActive ? "auto" : "none",
        }}
      >
        <Card
          style={{
            borderRadius: 16,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            width: "100%",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "scale(1.03)";
            e.currentTarget.style.boxShadow = "0px 6px 16px rgba(0, 0, 0, 0.2)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.1)";
          }}
        >
          <CardContent style={{ height: 120 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <img
                    src={supplierObject?.logo_url}
                    alt={supplierObject?.supplier_name}
                    width={isMobile ? 60 : 90}
                    style={{
                      maxWidth: "100%",
                      maxHeight: 90,
                      objectFit: "contain",
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={8}>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "bold",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {supplierObject?.supplier_name}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color={
                    isActive ||
                    supplierObject.refs_supplier_status.status === "Cancelled"
                      ? "primary"
                      : "error"
                  }
                >
                  {isActive
                    ? supplierObject.refs_supplier_status.status
                    : "Not Registered"}
                </Typography>
                <Typography variant="subtitle2" style={{ color: "#9E9E9E" }}>
                  {supplierObject?.last_updated
                    ? `Updated Until: ${supplierObject.last_updated}`
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Link>
    </Grid>
  );
}

export default SupplierTile;
